<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 5 / 14"
    viewBox="0 0 14 5"
  >
    <g>
      <path
        :fill="color"
        d="M13.546.708H.454a.312.312 0 0 0-.311.311v2.962c0 .172.14.311.311.311h13.092c.172 0 .311-.14.311-.311V1.019a.312.312 0 0 0-.311-.311z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B2A8C1',
    },
    size: {
      type: Number,
      default: 14,
    },
  },
};
</script>
